// import 'rxjs/add/operator/map';
// import 'rxjs/add/operator/take';
import { Injectable }             from '@angular/core';
import { Observable }             from 'rxjs/Observable';
import { Router, Resolve, RouterStateSnapshot,
         ActivatedRouteSnapshot } from '@angular/router';

import { ProductsService } from './products/products.service';
import { Product, Category, CategoryResponse, CategoryItems} from './products/product';
import { ControlsService } from './controls.service';
import { map, switchMap, tap, take } from 'rxjs/operators';
import { empty } from 'rxjs/observable/empty';
import { of } from 'rxjs/observable/of';
import { from } from 'rxjs/observable/from';

import { SearchService } from './search.service';

@Injectable()
export class SearchResolverService implements Resolve<any> {
  constructor(
    private ps: ProductsService,
    private router: Router,
    private cs: ControlsService,
    private search: SearchService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    let search:string = route.paramMap.get('s');

    let id: number = parseInt(search, 1000);


  // if (isNaN(id)) {
  //   return of(this.search.searchRequest(search));
  // } else {
  //   return this.search.returnById(id);

  // }


  if (isNaN(id)) {
    return this.cs.getFreeControlSubject()
    .pipe(
      take(1),
      map(freeMod => (freeMod)? 'free': ''),
      switchMap(freeControl => this.ps.getProducts({s: search, type: freeControl, page: 1, limit: 1000}))

    );

  }else {
    return this.ps.getProductById(id);

  }
}
}




// WEBPACK FOOTER //
// ./src/app/search-resolver.service.ts